import React, { Fragment, useState, createElement, useEffect } from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Collapse,
} from "@material-ui/core";
import { useHistory, matchPath } from "react-router-dom";
import _ from "lodash";
import { ArrowDropUp, ArrowRight, ArrowUpward } from "@material-ui/icons";

const NavigationList = ({ data, closeNav }) => {
  const [openChildMenu, setopenChildMenu] = useState(false);
  const history = useHistory();
  useEffect(() => {
    let open1 = matchPath(history.location.pathname, {
      path: data.href,
      exact: false,
    });
    if (open1) {
      data.active = true;
    } else {
      data.active = false;
    }
    _.each(data.children, (o2) => {
      let open2 = matchPath(history.location.pathname, {
        path: o2.href,
        exact: false,
      });
      if (open2) {
        o2.active = true;
        data.active = true;
        setopenChildMenu(true);
      } else {
        o2.active = false;
      }
    });
    if (data.children) {
      _.each(data.children, (o2) => {
        if (o2.children) {
          _.each(o2.children, (o2) => {
            let open2 = matchPath(history.location.pathname, {
              path: o2.href,
              exact: false,
            });
            if (open2) {
              setopenChildMenu(true);
            }
          });
        }
      });
      _.each(data.children, (o2) => {
        if (o2.children) {
          _.each(o2.children, (o2) => {
            _.each(o2.children, (o2) => {
              let open2 = matchPath(history.location.pathname, {
                path: o2.href,
                exact: false,
              });
              if (open2) {
                setopenChildMenu(true);
              }
            });
          });
        }
      });
    }
    // eslint-disable-next-line
  }, [history.location.pathname]);
  function checkShowAccess(data) {
    let returnstatement;
    if (data.Access) {
      if (data.children) {
        if (data.children.length) {
          returnstatement = true;
        } else {
          returnstatement = false;
        }
      } else {
        returnstatement = data.Access;
      }
    } else {
      returnstatement = false;
    }
    return returnstatement;
  }
  return (
    <Fragment>
      {checkShowAccess(data) && (
        <ListItem
          button
          onClick={() => {
            if (!data.children) {
              history.push(data.href);
              closeNav();
            }
            if (openChildMenu) {
              setopenChildMenu(false);
            } else {
              setopenChildMenu(true);
            }
          }}
        >
          {data.icon && <ListItemIcon>{createElement(data.icon)}</ListItemIcon>}
          <ListItemText primary={data.name} />
          {openChildMenu
            ? data.children && (
                <Box display="flex">
                  <ArrowDropUp />
                </Box>
              )
            : data.children && (
                <Box display="flex">
                  <ArrowRight />
                </Box>
              )}
        </ListItem>
      )}
      {data.children && (
        <ChildRoutes
          openChildMenu={openChildMenu}
          arr={data.children}
          closeNav={closeNav}
        />
      )}
    </Fragment>
  );
};
const ChildRoutes = ({ openChildMenu, arr, closeNav }) => {
  const [open, setopen] = useState();
  useEffect(() => {
    setopen(openChildMenu);
  }, [openChildMenu]);
  return arr.map((data, i) => (
    <Fragment key={i}>
      <Collapse in={Boolean(open)}>
        <NavigationList data={data} closeNav={closeNav} />
      </Collapse>
    </Fragment>
  ));
};

export default NavigationList;
